import { ReactElement } from 'react';

import { Box, Stack, TableCell, TableRow, Typography } from '@mui/material';
import { PrimaryButton } from '@/components';
import RefreshIcon from '@mui/icons-material/Refresh';

type RecentActivityErrorProps = {
  refetch: VoidFunction;
};

export const RecentActivityError = (
  props: RecentActivityErrorProps,
): ReactElement => {
  return (
    <TableRow>
      <TableCell
        colSpan={5}
        sx={{
          borderBottom: 'none',
        }}
      >
        <Box
          sx={{
            height: 'calc(100vh - 700px)',
            display: 'grid',
            placeItems: 'center',
          }}
        >
          <Stack alignItems="center" spacing={4}>
            <Typography fontSize={24} fontWeight={600}>
              Oops! Something went wrong.
            </Typography>

            <PrimaryButton onClick={props.refetch} startIcon={<RefreshIcon />}>
              Retry
            </PrimaryButton>
          </Stack>
        </Box>
      </TableCell>
    </TableRow>
  );
};
